import { Card as StyledCard, Text, Grid, Box } from '@/theme/index';
import { BoxWithLine, GradientLine, GridStack, LineCard } from './components';
import { LinkButton } from '../components';

interface ValuationLineCardProps {
  cleanTradeValue: string;
  roughTradeValue: string;
  averageTradeValue: string;
  toggleModal: (modalType: string | null) => void;
}

const styles = {
  color: 'black',
  textWeight: '300',
  textDecoration: 'underline',
};

export const ValuationLineCard = ({
  cleanTradeValue = '0',
  roughTradeValue = '0',
  averageTradeValue = '0',
  toggleModal,
}: ValuationLineCardProps) => {
  return (
    <StyledCard variant="outlined">
      <Grid container gap={0}>
        <Grid item xs={8} md={12}>
          <GridStack>
            <BoxWithLine>
              <LineCard marginTop="100px">
                <LinkButton
                  variant="text"
                  sx={styles}
                  onClick={() => toggleModal('cleanTradeValue')}
                >
                  <Text variant="body2">Clean Trade-in</Text>
                </LinkButton>
                <Text variant="body2" fontWeight="bold">
                  {cleanTradeValue} or more
                </Text>
              </LineCard>
            </BoxWithLine>
            <BoxWithLine color="primary" height="tall">
              <LineCard marginTop="38px" color="primary">
                <LinkButton
                  variant="text"
                  sx={styles}
                  onClick={() => toggleModal('averageTradeValue')}
                >
                  <Text variant="body2">Average Trade-in</Text>
                </LinkButton>
                <Text variant="h2">{averageTradeValue}</Text>
              </LineCard>
            </BoxWithLine>
            <BoxWithLine>
              <LineCard marginTop="100px">
                <LinkButton
                  variant="text"
                  sx={styles}
                  onClick={() => toggleModal('roughTradeValue')}
                >
                  <Text variant="body2">Rough Trade-in</Text>
                </LinkButton>
                <Text variant="body2" fontWeight="bold">
                  {roughTradeValue} or less
                </Text>
              </LineCard>
            </BoxWithLine>
          </GridStack>
        </Grid>
        <Grid item xs={0.5} md={12}>
          <GradientLine />
        </Grid>
        <Grid item xs={3.5} md={12} display="flex">
          <Box
            sx={(theme) => ({
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              [theme.breakpoints.up('md')]: {
                flexDirection: 'row-reverse',
                width: '100%',
                marginX: theme.spacing(2),
              },
            })}
          >
            <Text variant="body2" marginY={3} marginX={0.5}>
              Best condition
            </Text>
            <Text variant="body2" marginY={3} marginX={0.5}>
              Worst condition
            </Text>
          </Box>
        </Grid>
      </Grid>
    </StyledCard>
  );
};
